module.exports = __webpack_public_path__ + "static/media/arrows-icons.0f9fc9f2.svg";